import config from "../../app.json";
import axios from "axios";

import "./Styles/event-detail.scss";
import "./Styles/add-new-channel.scss";
import "react-toggle/style.css";

import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Row, Col, Button } from "react-bootstrap";
import FieldText from "../../Components/Fields/FieldText";
import AlertComponent from "../../Components/AlertComponent";
import FieldSelect from "../../Components/Fields/FieldSelect";
import AddOrEditInput from "../../Components/AddAndEditChannel/AddOrEditInput";
import AddOrEditOutput from "../../Components/AddAndEditChannel/AddOrEditOutput";

function AddNewChannel(props) {
  let navigate = useNavigate();

  const { onAdd, fromListing, id } = props;

  const [channelId, setChannelId] = useState(null);
  const [channelName, setChannelName] = useState(null);
  const [showAddInput, setShowAddInput] = useState(id ? false : true);
  const [showAddOutput, setShowAddOutput] = useState(false);
  const [currentElement, setCurrentElement] = useState(null);
  const visibilities = [{ label: "Public", value: false }, { label: "Private", value: true }];
  const [isPrivate, setIsPrivate] = useState({ label: "Public", value: false });

  const [inputs, setInputs] = useState([]);
  const [outputs, setOutputs] = useState([]);
  const [availableElementsInputs, setAvailableElementsInputs] = useState([]);

  useEffect(() => {
    if (!id) {
      return;
    }
    getChannelInfo();
  }, [id]);

  const getChannelInfo = async () => {
    await axios
      .post(config.API + "/api/channel/getChannel", {
        id: id,
      })
      .then((res) => {
        if (res.status === 200 && res.data) {
          setChannelId(res.data.id);
          setChannelName(res.data.name);
          setIsPrivate(visibilities.find(x => x.value == res.data?.private ?? false));

          const inputsApi = res.data.inputs.$values.map(
            ({ $id, ...item }) => item
          );
          const outputsApi = res.data.outputs.$values.map(
            ({ $id, ...item }) => item
          );

          setInputs(inputsApi);
          setOutputs(outputsApi);
        }
      })
      .catch(function (error) {
        return AlertComponent(
          "Error",
          error?.response?.data?.error ||
          error?.response?.data?.message ||
          error?.message,
          { icon: `error` }
        );
      });
  };

  const handleEditInput = (element) => {
    setShowAddOutput(false);
    setShowAddInput(true);
    setCurrentElement(element);
  };

  const handleEditOutput = (element) => {
    setShowAddInput(false);
    setShowAddOutput(true);
    setCurrentElement(element);
  };

  const handleReturnAvailableElements = (elementInput) => {
    setAvailableElementsInputs((oldInputs) => {
      const newInputs = [...oldInputs];
      newInputs.push(elementInput);
      return newInputs;
    });
  };
  const handleDeleteInputElements = (index) => {
    setInputs((oldInputs) => {
      const newInputs = [...oldInputs];
      if (index !== -1) {
        const elementInput = newInputs[index];
        if (elementInput.attached) {
          handleReturnAvailableElements(elementInput);
        }
        newInputs.splice(index, 1);
      }
      return newInputs;
    });
  };

  const handleDeleteOutputElements = (index) => {
    setOutputs((oldOutputs) => {
      const newOutputs = [...oldOutputs];
      if (index !== -1) {
        newOutputs.splice(index, 1);
      }
      return newOutputs;
    });
  };

  const handleAddNewElementsInput = (updatedItem) => {
    if (updatedItem.attached) {
      const newAvailableList = [...availableElementsInputs].filter(
        (x) => x.id !== updatedItem.id
      );
      setAvailableElementsInputs(newAvailableList);
    }
    let found = false;
    const updatedItems = inputs.map((item) => {
      if (item.id === updatedItem.id) {
        found = true;
        return updatedItem;
      } else {
        return item;
      }
    });

    if (found) {
      setInputs(updatedItems);
      setCurrentElement(null);
    } else {
      setInputs([...inputs, updatedItem]);
    }

    setShowAddInput(false);
  };

  const handleAddNewElementsOutput = (item) => {
    if (item.id) {
      const outputsOld = outputs.filter(x => x.id !== item.id);
      setOutputs([...outputsOld, item]);
    } else {
      setOutputs([...outputs, item]);
    }
    setShowAddOutput(false);
  };

  const handleCancelInput = () => {
    setCurrentElement(null);
    setShowAddInput(false);
  };

  const handleCancelOutput = () => {
    setCurrentElement(null);
    setShowAddOutput(false);
  };

  const handleAddChannel = () => {
    if (!channelName) {
      return AlertComponent("Error", "Channel name is required", {
        icon: `error`,
      });
    }

    if (!inputs || !inputs.length) {
      return AlertComponent("Error", "Select at least one input", {
        icon: `error`,
      });
    }

    if (!outputs || !outputs.length) {
      return AlertComponent("Error", "Select at least one output", {
        icon: `error`,
      });
    }

    let item = {
      name: channelName,
      inputs: inputs,
      outputs: outputs,
      private: isPrivate?.value ?? false
    };

    if (channelId) {
      item.id = channelId;
    }

    axios
      .post(config.API + "/api/Channel/saveChannel", item)
      .then((res) => {
        if (res.status === 200 && res.data) {
          if (onAdd) {
            onAdd(res.data);
          }

          if (fromListing) {
            AlertComponent("Success", "Channel has been saved successfully");
            return navigate("/listingChannels", { replace: false });
          } else {
            return AlertComponent(
              "Success",
              "Channel has been saved successfully"
            );
          }
        }
      })
      .catch(function (error) {
        return AlertComponent(
          "Error",
          error?.response?.data?.error ||
          error?.response?.data?.error ||
          error?.message,
          { icon: `error` }
        );
      });
  };

  const allowedOutputEdit = ['Facebook', 'RTMP', 'YouTube']

  return (
    <Row>
      <Col className="col-md-4 mt-4 ">
        <div className="new-channel-container">
          <h3>{`${id ? `Edit` : `New`} Channel`}</h3>
          <FieldText
            label="Channel Name"
            type="text"
            onChange={(x) => setChannelName(x.target.value)}
            placeholder="Channel Name"
            value={channelName}
            required={true}
            inputClassName={`inputOption`}
            disabled={id != null}
          />

          <FieldSelect
            label={`Visibility`}
            options={visibilities}
            onChange={setIsPrivate}
            value={isPrivate}
            placeholder={`Visibility`}
            required={false}
          />

          <div className="form-group">
            <div className="add-new-channel-container">
              <div className="left-item">
                <label htmlFor="inputs">Inputs</label>
              </div>
              <div
                className={`right-item ${!showAddInput && !showAddOutput ? "" : "d-none"
                  }`}
                onClick={() => setShowAddInput(true)}
              >
                Add
              </div>
            </div>
            <div className="inputs col-md-12" id="inputs">
              {inputs?.map((x, index) => {
                return (
                  <div className="micro-elements">
                    <Row className="align-items-center gx-2">
                      <Col md={8}>
                        <div className="inputs-elements item">
                          {`${x.name} - ${x.inputType}`}
                        </div>
                      </Col>
                      <Col md={2}>
                        <Button
                          type="button"
                          className="action-button delete-btn"
                          onClick={() => handleDeleteInputElements(index)}
                          disabled={showAddInput}
                        />
                      </Col>
                      <Col md={2}>
                        <Button
                          type="button"
                          className="action-button edit-btn"
                          onClick={() => handleEditInput(x)}
                          disabled={showAddInput}
                        />
                      </Col>
                    </Row>
                  </div>
                );
              })}
              {inputs.length == 0 && (
                <div className="inputs-elements">None</div>
              )}
            </div>
          </div>
          <div className="form-group">
            <div className="add-new-channel-container">
              <div className="left-item">
                <label htmlFor="outputs">Outputs</label>
              </div>
              <div
                className={`right-item ${!showAddOutput && !showAddInput ? "" : "d-none"
                  }`}
                onClick={() => setShowAddOutput(true)}
              >
                Add
              </div>
            </div>

            <div className="outputs col-md-12" id="outputs">
              {outputs?.map((x, index) => {
                return (
                  <div className="micro-elements">
                    <Row className="align-items-center gx-2">
                      <Col md={8}>
                        <div className="inputs-elements item">
                          {`${x.name} - ${x.outputType}`}
                        </div>
                      </Col>
                      <Col md={2}>
                        <Button
                          type="button"
                          className="action-button delete-btn"
                          onClick={() => handleDeleteOutputElements(index)}
                          disabled={showAddOutput}
                        />
                      </Col>
                      <Col md={2}>
                        <Button
                          type="button"
                          className="action-button edit-btn"
                          onClick={() => handleEditOutput(x)}
                          disabled={showAddOutput || !allowedOutputEdit.includes(x.outputType) || !x.id}
                        />
                      </Col>
                    </Row>
                  </div>
                );
              })}

              {outputs.length == 0 && (
                <div className="outputs-elements">None</div>
              )}
            </div>
          </div>
          <div className="d-flex justify-content-end pt-2">
            <Button onClick={handleAddChannel} className="dark-btn">
              {`${id ? `Update` : `Create`} Channel`}
            </Button>
          </div>
        </div>
      </Col>

      {showAddInput && (
        <Col className="col-md-8 mt-4">
          <AddOrEditInput
            usedInputs={inputs}
            handleAddNewElementsInput={handleAddNewElementsInput}
            handleCancelInput={handleCancelInput}
            currentElement={currentElement}
            availableElements={availableElementsInputs}
          />
        </Col>
      )}

      {showAddOutput && (
        <Col className="col-md-8 mt-4">
          <AddOrEditOutput
            handleAddNewElementsOutput={handleAddNewElementsOutput}
            hasS3={outputs.find((x) => x.outputType === `S3`)}
            hasMediaPackage={outputs.find(
              (x) => x.outputType === `MediaPackage`
            )}
            handleCancelOutput={handleCancelOutput}
            currentElement={currentElement}
          />
        </Col>
      )}
      {!showAddInput && !showAddOutput && (
        <Col className="col-md-8 mt-4">
          <div className="cc-card">
            <p className="instructions">
              Please select add your input or output.{" "}
            </p>
          </div>
        </Col>
      )}
    </Row>
  );
}

export default AddNewChannel;
